let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hBQJN")).then(() => parcelRequire('g7CwV'));